import React from 'react';
import Autopara from '../Autopara/Autopara';

const images = [
  'https://www.nexel.in/media/blog_images/web_development_Z62jy4k.jpg',
  'https://t3.ftcdn.net/jpg/02/14/87/96/360_F_214879686_R3HFJlk6WLr1kcdvy6Q9rtNASKN0BZBS.jpg',
  'https://blog.pixelfreestudio.com/wp-content/uploads/2024/07/0_M4bxiCIjcTK-2Xr6-1024x538.jpg',
];

const paragraphText = `
  <strong>We offer comprehensive web development services</strong> tailored to meet modern business needs.
  Our team crafts <em>responsive, user-friendly websites</em> that function seamlessly across all devices.<br/><br/>
  We specialize in front-end technologies like <strong>React</strong>, <strong>Vue</strong>, and <strong>Angular</strong>,
  and powerful back-end frameworks such as <strong>Node.js</strong>, <strong>Django</strong>, and <strong>Laravel</strong>.<br/><br/>
  Every website we build is optimized for speed, accessibility, and SEO. From corporate websites to
  custom web apps, we integrate APIs, databases, and cloud deployment with ease. Let us bring your digital
  vision to life with <span style="color: teal; font-weight: bold;">clean code</span> and <span style="color: teal; font-weight: bold;">scalable architecture</span>.
`;

function Autopara1() {
  return <Autopara images={images} text={paragraphText} />;
}

export default Autopara1;
